import { render, staticRenderFns } from "./TabStaffSale.vue?vue&type=template&id=13100c9f&scoped=true&"
import script from "./TabStaffSale.vue?vue&type=script&lang=js&"
export * from "./TabStaffSale.vue?vue&type=script&lang=js&"
import style0 from "./TabStaffSale.vue?vue&type=style&index=0&id=13100c9f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13100c9f",
  null
  
)

export default component.exports